module.exports = __webpack_public_path__ + "img/20190814160927866.d8e35d7a.png";